import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { useBorrowerThirdPartyExpectation } from '../../../../../queries/BorrowerFields/ThirdPartyFields';

export const CompensationExpectation: React.FC = () => {
    const label = 'Does a broker or other third party reasonably expect compensation for arranging this loan?';
    const [finalizeThirdPartyClaim, set_finalizeThirdPartyClaim] = useBorrowerThirdPartyExpectation();
    return (
        <YesNoToggleButton
            id='compensation-expectation'
            value={finalizeThirdPartyClaim ?? null}
            onItemClick={(e: ButtonGroupTypes.ItemClickEvent) => set_finalizeThirdPartyClaim(e.itemData?.id === 'Yes')}
            width='230px'
            height='40px'
            label={label}
            labelSize={ToggleButtonLabelSize.Medium}
        />
    );
};
